import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { OrderHistory } from './OrderHistory';
import { CouponRedeemptionHistory } from './CouponRedeemptionHistory';
import { Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PrimaryButton from 'components/Button/PrimaryButton';
import InputField from 'components/InputField';
import OrderSearch from './OrderSearch';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function HistoryTabs({ loading, setLoading }: { loading: any, setLoading: any }) {
    const [value, setValue] = React.useState(0);
    const [refresh, setRefresh] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <Box>   <OrderSearch refresh={refresh} /></Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: "space-between" }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Your Orders" {...a11yProps(0)} />
                    <Tab label="Rewards History" {...a11yProps(1)} />
                </Tabs>
                <Box paddingTop='16px'>
                    <RefreshIcon onClick={() => setRefresh((prev) => prev + 1)} sx={{ cursor: 'pointer', '&:hover': { color: '#0066FF' } }} fontSize='large' />
                </Box>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <OrderHistory loading={loading} setLoading={setLoading} refresh={refresh} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <CouponRedeemptionHistory loading={loading} setLoading={setLoading} />
            </CustomTabPanel>

        </Box>
    );
}